<app-data-table-manager
  [columnConfigs]="columnConfigs"
  [filterConfig]="DEFAULT_FILTER_CONFIG"
  [tableData]="tableData"
  [fieldFilters]="fieldFilters"
  [displayInfo]="displayInfo"
  [domainMarketLang]="domainMarketLang"
  [facetGroups]="facetGroups"
  [tableName]="'packs'"
  [defaultSortActive]="defaultSortActive"
  [defaultSortDirection]="defaultSortDirection"
  (loadDataRequested)="loadData($event)"
  ><app-filter-domain-market-lang
    [domainMarketLang]="domainMarketLang"
    [fieldsFilterDomainMarketLang]="fieldsFilterDomainMarketLang"
    (filterChange)="handleGlobalFilterChange($event)"
  ></app-filter-domain-market-lang
></app-data-table-manager>
